


































import { Component, Mixins } from 'vue-property-decorator';
import AccountSettings from '@/mixins/accountSettings.mixin';
import cartStore from '@/store/modules/checkout/cart/module';
import APP_CONST from '@/constants/AppConst';

@Component
export default class CheckoutPaymentPlanSelector extends Mixins(AccountSettings) {
  public currentPaymentPlanSelection = 0;
  public sessionPriceDecimalPrecision = APP_CONST.SESSION_PRICE_DECIMAL_PRECISION;

  get paymentPlans() {
    return cartStore.paymentPlans;
  }
}
